import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-view-bill-files',
	templateUrl: './view-bill-files.component.html',
	styleUrl: './view-bill-files.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class ViewBillFilesComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	caseDetails: any = {};
	pageLoading1 = false;
	pageLoading2 = false;
	pagetitle: string = "Bill Files";
	moduleAccess = "Full";
	allBillFiles: any[] = [];
	File_Storage_URL = environment.File_Storage_URL;

	constructor(private sanitizer: DomSanitizer, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService) { }
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/bill-files/" + this.uId, name: this.pagetitle });
			this.getCaseDetails();
		});
	}

	getCaseDetails() {
		this.pageLoading1 = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.caseDetails = data;
				this.getBillPdfs();
				/* this.getFolloupBillsByCase(); */
			}, error: (error) => {
				this.pageLoading1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getBillPdfs() {
		this.pageLoading2 = true;
		this.apiService.getCaseBillsPdfs(this.caseDetails.id).subscribe({
			next: (data: any) => {
				this.allBillFiles = data;
				this.pageLoading2 = false;
			}, error: (error) => {
				this.pageLoading2 = false;
				this.allBillFiles = [];
			}
		})
	}

	getFolloupBillsByCase() {
		this.pageLoading2 = true;
		this.apiService.getFolloupBillsByCase({ id: this.caseDetails.id }).subscribe({
			next: (data: any) => {
				let allBillFiles: any[] = [];
				data.data.map((bill: any) => {
					bill.files = bill.files === null ? [] : bill.files;
					bill.gpay_files = bill.gpay_files === null ? [] : bill.gpay_files;
					bill.qrcode_files = bill.qrcode_files === null ? [] : bill.qrcode_files;
					allBillFiles = [...allBillFiles, ...bill.files, ...bill.gpay_files, ...bill.qrcode_files];
				});
				this.allBillFiles = allBillFiles;
				this.pageLoading2 = false;
			}, error: (error) => {
				this.pageLoading2 = false;
				this.allBillFiles = [];
			}
		})
	}

	getFileName(file: string) {
		try {
			return file.split("/").pop() || "";
		} catch (error) {
			return file;
		}
	}

	checkImage(file: string) {
		try {
			const ext: string = file.split(".").pop() || "";
			const ext_lower = ext.toLowerCase();
			return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
		} catch (error) {
			return false;
		}
	}

	checkPdf(file: string) {
		try {
			const ext: string = file.split(".").pop() || "";
			const ext_lower = ext.toLowerCase();
			return ext_lower == "pdf";
		} catch (error) {
			return false;
		}
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}
}
